<template>

    <div class="checkout-form">
        <div class="closeForm" v-on:click="closeForm()">
            <i class="icon-times"></i>
        </div>
        <h3>Checkout</h3>
        <form-builder
          v-bind:submitMethod="submitLoginFunction"
          v-bind:formData="loginForm"
          v-on:form-error="setLoginFormError"
          v-if="loginFormActive"
        >
            <div class="col-md-12 form-group">
              <h4>Account login <a href="#" class="login" v-on:click.stop.prevent="loginFormActive=false">(Changed your mind? Click here)</a></h4>
            </div>
            <div class="col-6 form-group">
                <form-input name="login-email" label="Email Address:" v-model="loginForm.data.email" v-bind:validation="loginForm.validation.email" v-bind:messages="loginForm.error_messages.email" v-bind:class="['yellowInput']"></form-input>
            </div>
            <div class="col-6 form-group">
                <form-input name="login-password" label="Password:" v-model="loginForm.data.password" type="password" v-bind:validation="loginForm.validation.password" v-bind:messages="loginForm.error_messages.password" v-bind:class="['yellowInput']"></form-input>
            </div>
            <div class="col-12 forgotPassword">
              <a href="#" v-on:click.stop.prevent="changeRouteTo('reset')">Forgot your password?</a>
            </div>

            <div class="col-12 form-group form-footer">
              <div class="row">
                <div class="col-12" v-if="loginForm.validation.main">
                  <p class="errorMsg"><i class="icon-warning-sign"></i> {{ loginForm.validation.main }}</p>
                </div>
                <div class="col-6 col-lg-8"></div>
                <div class="col-6 col-lg-4 submitContainer">
                  <form-submit label="Login to Account" v-bind:status="loginForm.status" v-bind:class="['whiteSubmit']"></form-submit>
                </div>
              </div>
            </div>

        </form-builder>

        <form-builder
          v-if="!purchaseSuccess && !loginFormActive"
          v-bind:submitMethod="purchaseFunction"
          v-bind:formData="purchaseForm"
          v-on:form-error="setPurchaseFormError"
        >
        <div class="col-md-12 form-group">
          <h4>Account details <a href="#" class="login" v-if="!authed" v-on:click.stop.prevent="loginFormActive=true">(Already have an account? Click here)</a></h4>

          <div class="authorised" v-if="!purchaseForm.data.gift">
            <p v-if="authed">You are logged in with email address <strong>{{ authed.email }}</strong>. <a href="#" v-on:click.stop.prevent="logOut()">Not you? click here to logout</a></p>
          </div>
        </div>
        <div class="col-6 form-group" v-if="!authed">
            <form-input
              name="purchase-name"
              v-bind:label="purchaseForm.data.gift ? 'Gift recipient name' : 'Full name'"
              placeholder="Enter full name"
              v-model="purchaseForm.data.name"
              v-bind:validation="purchaseForm.validation.name"
              v-bind:messages="purchaseForm.error_messages.name"
              v-bind:class="['yellowInput']"
            ></form-input>
        </div>

        <div class="col-6 form-group" v-if="!authed">
            <form-input
              name="purchase-email"
              v-bind:label="purchaseForm.data.gift ? 'Gift recipient email' : 'Email Address'"
              placeholder="Enter email address"
              v-model="purchaseForm.data.email"
              v-bind:validation="purchaseForm.validation.email"
              v-bind:messages="purchaseForm.error_messages.email"
              v-bind:class="['yellowInput']"
            ></form-input>
        </div>

        <div class="col-6 form-group" v-if="!authed && !purchaseForm.data.gift">
            <form-input
              name="purchase-password"
              v-bind:type="'password'"
              v-bind:label="'Password'"
              placeholder="Enter a password"
              v-model="purchaseForm.data.password"
              v-bind:validation="purchaseForm.validation.password"
              v-bind:messages="purchaseForm.error_messages.password"
              v-bind:class="['yellowInput']"
            ></form-input>
        </div>

        <div class="col-12 seperator">
            <p class="giftHelp" v-if="purchaseForm.data.gift">If you don't have the email for the gift recipient, you can enter your own</p>
        </div>

        <div class="col-12 form-group giftMessage" v-if="purchaseForm.data.gift">
            <form-input
              name="purchase-gift-message"
              label="Gift message"
              placeholder="Enter gift message"
              v-model="purchaseForm.data.gift_message"
              v-bind:validation="[]"
              v-bind:class="['yellowInput']"
            ></form-input>
        </div>

        <!--
        <div class="col-12 form-group nextStep" v-if="!showCardDetails">
          <p class="errorMsg" v-if="nextError"><i class="icon-warning-sign"></i> Check the form for any incomplete fields</p>
          <a href="#" v-on:click.stop.prevent="nextFormStep()">Next</a>
        </div>
        -->

        <div class="col-md-12 form-group whiteInput" v-if="showCardDetails">
          <h4><span v-if="purchaseForm.data.gift">Your card</span><span v-else>Card</span> details</h4>
          <form-input
            v-if="purchaseForm.data.gift"
            name="purchase-billing-name"
            placeholder="Enter cardholder name"
            v-model="purchaseForm.data.billing_name"
            v-bind:validation="purchaseForm.data.gift ? ['required'] : []"
            v-bind:messages="purchaseForm.error_messages.billing_name"
            v-bind:class="['yellowInput','cardField']"
          ></form-input>
          <div class="my-input" id="card-element"></div>
        </div>

        <div class="promotionalWrapper" v-if="$activePromotionField && showCardDetails && !promotion">
          <label v-on:click="showDiscount=!showDiscount">Have a promotional code?</label>
          <div class="promotionalField" v-if="showDiscount">
            <input type="text" class="form-control" name="discount" v-bind:placeholder="'Enter a code'" v-model="purchaseForm.data.discount">
            <a href="#" class="promotionalBtn" v-on:click.stop.prevent="checkApplyDiscount()">
              <span v-if="!discountSubmitting">Add code</span>
              <span v-else><i class="icon-line-loader icon-spin"></i></span>
            </a>
            <div class="clear"></div>
            <p class="discountMessage"
              v-if="discountResponse"
              v-bind:class="{ 'messageSuccess': discountResponseSuccess, 'messageError': !discountResponseSuccess }"
            >
              <i class="icon-warning-sign" v-bind:class="{ 'icon-check': discountResponseSuccess, 'icon-warning-sign': !discountResponseSuccess }"></i>
              {{ discountResponse }}
          </p>
          </div>
        </div>

        <div class="col-md-12 form-group checkBoxWrapper whiteInput" v-if="showCardDetails">
          <div class="checkBox"
            v-bind:class="{ activated:  purchaseForm.data.subscribe }"
            v-on:click="purchaseForm.data.subscribe=!purchaseForm.data.subscribe"
          >
            <i class="icon-check" v-if="purchaseForm.data.subscribe"></i>
          </div>
          <label>Subscribe to receive updates about future offers and new tales</label>
        </div>

        <div class="col-12 form-group form-footer" v-if="showCardDetails">
          <div class="row">
            <div class="col-12" v-if="purchaseForm.validation.main">
              <p class="errorMsg"><i class="icon-warning-sign"></i> {{ purchaseForm.validation.main }}</p>
            </div>
            <div class="col-6 col-lg-8 priceInformation">
                <p v-if="tale_id == 1 && type == 'Digital'">The Mother (Digital)</p>
                <p v-if="tale_id == 2 && type == 'Digital'">The Forest (Digital)</p>
                <p v-if="tale_id == 3 && type == 'Digital'">The Dolls House (Digital)</p>

                <p v-if="tale_id == 1 && type == 'Printable'">Escape The Date (Printable)</p>
                <p v-if="tale_id == 2 && type == 'Printable'">Death Marked Love (Printable)</p>
                <p v-if="tale_id == 3 && type == 'Printable'">The Missing Moviestar (Printable)</p>
                <p v-if="tale_id == 4 && type == 'Printable'">Mystery Manor (Printable)</p>
                <p v-if="tale_id == 5 && type == 'Printable'">The Eggcelent Adventure (Printable)</p>
                <p v-if="tale_id == 6 && type == 'Printable'">The Wicked Wand (Printable)</p>

                <p v-if="type == 'Collection'">The Cursed Collection (4 Games)</p>

                <p class="totalPrice" v-if="type == 'Digital' || type == 'Printable'">Total Price: <span class="discounted" v-if="purchaseForm.data.discount_id">{{ currencySign + subtotalPrice }}</span> <span>{{ currencySign + totalPrice }}</span></p>
                <p class="totalPrice" v-else>Total Price: <span>{{ currencySign + collectionPrice }}</span></p>
            </div>
            <div class="col-6 col-lg-4 submitContainer">
              <form-submit label="Check out now" v-bind:status="purchaseForm.status" v-bind:class="['whiteSubmit']"></form-submit>
            </div>
          </div>
        </div>

      </form-builder>
      <div class="orderSuccess" v-if="purchaseSuccess && !purchaseForm.data.gift">
        <h3>Thank you for your purchase!</h3>
        <p>We have sent you an email with your new account details. Click below to head to your account and start playing!</p>
        <p class="spamWarning"><u>Please note:</u> If you haven't shortly received an email from us please check your spam/junk or promotion folders</p>
        <a href="#" class="toAccount" v-on:click.stop.prevent="changeRouteTo('account')"><i class="icon-play"></i> Go to account and start playing</a>
      </div>
      <div class="orderSuccess" v-if="purchaseSuccess && purchaseForm.data.gift">
        <h3>Thank you for your gift purchase!</h3>
        <p>We have sent you an email to your gift recipient with your message, if you included one, and their new account details.</p>
      </div>

        <ul class="supported-payments">
            <!--
            <li class="icon-payment">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" x="0" y="0" width="38" height="24" viewBox="0 0 165.521 105.965" xml:space="preserve" aria-labelledby="pi-apple_pay"><title id="pi-apple_pay">Apple Pay</title><path fill="#000" d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"></path><path fill="#FFF" d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"></path><g><g><path fill="#000" d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"></path><path fill="#000" d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"></path></g><g><path fill="#000" d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"></path><path fill="#000" d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"></path><path fill="#000" d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"></path></g></g></svg>
            </li>
            <li class="icon-payment">
                <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-google_pay"><title id="pi-google_pay">Google Pay</title><path d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000" opacity=".07"></path><path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" fill="#FFF"></path><path d="M18.093 11.976v3.2h-1.018v-7.9h2.691a2.447 2.447 0 0 1 1.747.692 2.28 2.28 0 0 1 .11 3.224l-.11.116c-.47.447-1.098.69-1.747.674l-1.673-.006zm0-3.732v2.788h1.698c.377.012.741-.135 1.005-.404a1.391 1.391 0 0 0-1.005-2.354l-1.698-.03zm6.484 1.348c.65-.03 1.286.188 1.778.613.445.43.682 1.03.65 1.649v3.334h-.969v-.766h-.049a1.93 1.93 0 0 1-1.673.931 2.17 2.17 0 0 1-1.496-.533 1.667 1.667 0 0 1-.613-1.324 1.606 1.606 0 0 1 .613-1.336 2.746 2.746 0 0 1 1.698-.515c.517-.02 1.03.093 1.49.331v-.208a1.134 1.134 0 0 0-.417-.901 1.416 1.416 0 0 0-.98-.368 1.545 1.545 0 0 0-1.319.717l-.895-.564a2.488 2.488 0 0 1 2.182-1.06zM23.29 13.52a.79.79 0 0 0 .337.662c.223.176.5.269.785.263.429-.001.84-.17 1.146-.472.305-.286.478-.685.478-1.103a2.047 2.047 0 0 0-1.324-.374 1.716 1.716 0 0 0-1.03.294.883.883 0 0 0-.392.73zm9.286-3.75l-3.39 7.79h-1.048l1.281-2.728-2.224-5.062h1.103l1.612 3.885 1.569-3.885h1.097z" fill="#5F6368"></path><path d="M13.986 11.284c0-.308-.024-.616-.073-.92h-4.29v1.747h2.451a2.096 2.096 0 0 1-.9 1.373v1.134h1.464a4.433 4.433 0 0 0 1.348-3.334z" fill="#4285F4"></path><path d="M9.629 15.721a4.352 4.352 0 0 0 3.01-1.097l-1.466-1.14a2.752 2.752 0 0 1-4.094-1.44H5.577v1.17a4.53 4.53 0 0 0 4.052 2.507z" fill="#34A853"></path><path d="M7.079 12.05a2.709 2.709 0 0 1 0-1.735v-1.17H5.577a4.505 4.505 0 0 0 0 4.075l1.502-1.17z" fill="#FBBC04"></path><path d="M9.629 8.44a2.452 2.452 0 0 1 1.74.68l1.3-1.293a4.37 4.37 0 0 0-3.065-1.183 4.53 4.53 0 0 0-4.027 2.5l1.502 1.171a2.715 2.715 0 0 1 2.55-1.875z" fill="#EA4335"></path></svg>
            </li>
            -->
            <li class="icon-payment">
                <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-maestro"><title id="pi-maestro">Maestro</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><circle fill="#EB001B" cx="15" cy="12" r="7"></circle><circle fill="#00A2E5" cx="23" cy="12" r="7"></circle><path fill="#7375CF" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"></path></svg>
            </li>
            <li class="icon-payment">
                <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-master"><title id="pi-master">Mastercard</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><circle fill="#EB001B" cx="15" cy="12" r="7"></circle><circle fill="#F79E1B" cx="23" cy="12" r="7"></circle><path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"></path></svg>
            </li>
            <!--
            <li class="icon-payment">
                <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"></path><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"></path><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"></path></svg>
            </li>
            -->
            <li class="icon-payment">
                <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-visa"><title id="pi-visa">Visa</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z" fill="#142688"></path></svg>
            </li>
        </ul>

        <a href="#" class="cancelForm" v-on:click.stop.prevent="closeForm()"><i class="icon-times"></i> Cancel and close</a>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

import FormBuilder from '../components/FormBuilder.vue'
import FormInput from '../components/FormInput.vue'
import FormSubmit from '../components/FormSubmit.vue'

export default {
    name: 'BuyForm',
    components: {
        FormBuilder,
        FormInput,
        FormSubmit
    },
    props: {
        type: String,
        tale_id: [Number, String],
        currency: String,
        promotion: String
    },
    computed: {
      getAuth () {
        return this.$store.getters.getAuth
      },
      ...mapGetters(['getAuth']),
    },
    data() {
        return {
            authed: null,

            currencySign: "£",
            subtotalPrice: "9.99",
            totalPrice: "9.99",
            collectionPrice: "23.99",

            showCardDetails: false,
            nextError: false,

            loginFormActive: false,
            loginForm: {
              data: {
                email: this.$developer ? "adamwalker297@gmail.com" : null,
                password: this.$developer ? "Foxhound3285" : null,
              },
              validation: {
                email: ['required'],
                password: ['required'],
                main: null
              },
              error_messages: {},
              status: null
            },
            purchaseForm: {
                data: {
                    tale_id: null,
                    type: null,
                    customer_id: null,
                    name: this.$developer ? "Adam Walker" : null,
                    billing_name: this.$developer ? "Adam Walker" : null,
                    email: this.$developer ? "adamwalker297@gmail.com" : null,
                    password: null,
                    subscribe: false,
                    subtotal: "14.99",
                    discount: null,
                    discount_id: 0,
                    total: "9.99",
                    currency: "GBP",
                    gift: false,
                    gift_message: null,
                    cardholder: null,
                    stripe_intent: {}
                },
                validation: {
                    name: ['required'],
                    email: ['required','email'],
                    password: ['required'],
                    tale_id: ['required'],
                    type: ['required'],
                },
                error_messages: {},
                status: null
            },
            purchaseSuccess: false,

            showDiscount: false,
            discountSubmitting: false,
            discountResponse: null,
            discountResponseSuccess: false,

            stripe: null,
            elements: null,
            cardElement: null,
        }
    },
    methods: {
        setCurrency() {
            if (this.currency == 'USD') {
                this.currencySign = "$"
                this.subtotalPrice = "13.99"
                this.totalPrice = "13.99"
                this.collectionPrice = "28.99"
                this.purchaseForm.data.subscribe = true
                this.purchaseForm.data.currency = "USD"
                this.purchaseForm.data.subtotal = this.subtotalPrice
                this.purchaseForm.data.total = this.totalPrice
            }
        },
        checkApplyDiscount() {
            this.discountResponse = null

            if (!this.discountSubmitting && this.purchaseForm.data.discount) {
              this.discountSubmitting = true

              axios
                .post('https://api.cursed-tales.com/discounts/checker', {
                  type: this.purchaseForm.data.type,
                  tale_id: this.purchaseForm.data.tale_id,
                  currency: this.purchaseForm.data.currency,
                  code: this.purchaseForm.data.discount
                })
                .then(response => {
                    console.log("response", response)
                    this.pushMfqVariable("DISCOUNT_USED", this.purchaseForm.data.discount);
                    this.discountResponseSuccess = true
                    this.discountResponse = "Promotional code successfully added"
                    this.discountSubmitting = false

                    this.purchaseForm.data.discount_id = response.data.discount_id
                    this.subtotalPrice = response.data.price.subtotal
                    this.totalPrice = response.data.price.total
                    this.purchaseForm.data.subtotal = response.data.price.subtotal
                    this.purchaseForm.data.total = response.data.price.total

                    setTimeout(() => {
                      this.showDiscount = false
                      this.purchaseForm.data.discount = null
                      this.discountResponse = null
                    }, 2000)
                })
                .catch(error => {
                    console.log(error.response)
                    this.discountResponseSuccess = false
                    this.discountResponse = error.response.data.error.message
                    this.discountSubmitting = false
                })
            }
        },
        buyGift(status) {
          this.purchaseForm.data.gift_message = null;
          this.purchaseForm.data.gift = status;
          if (status)
            this.purchaseForm.validation.password = []
          else
            this.purchaseForm.validation.password = ['required']
        },

        setLoginFormError(error) {
          this.loginForm.validation.main = error
          setTimeout(() => {
            this.loginForm.validation.main = null
          }, 4000);
        },
        submitLoginFunction: function () {
          this.loginForm.status = "loading";

          axios
            .post('https://api.cursed-tales.com/auth', this.loginForm.data)
            .then(response => {
              console.log("response", response)
              sessionStorage.setItem('Cursed_CustomerReference', response.data.customer.reference);
              this.$cookies.set('Cursed_CustomerReference', response.data.customer.reference, 60 * 60 * 24);
              this.$store.dispatch("setAuth", response.data.customer)
              this.authed = response.data.customer
              this.purchaseForm.data.customer_id = this.authed.id
              this.purchaseForm.data.name = this.authed.name
              this.purchaseForm.data.email = this.authed.email
              this.purchaseForm.validation.name = []
              this.purchaseForm.validation.email = []
              this.purchaseForm.validation.password = []
              this.toggleCardDetails(2000)

              setTimeout(() => {
                this.loginFormActive = false
                this.loginForm.status = null;
              }, 1000);
            })
            .catch(error => {
              console.log(error)
              this.loginForm.status = "error";
              //this.form.error_messages = error.response.data.error.validation_failed
              this.loginForm.validation.main = "Incorrect username and/or password"
            })
        },
        nextFormStep() {
          this.nextError = false
          if (this.purchaseForm.data.name && this.purchaseForm.data.email && this.purchaseForm.data.password) {
            this.toggleCardDetails(500)
          } else {
            this.nextError = true
          }
        },
        setPurchaseFormError(error) {
          this.purchaseForm.validation.main = error
          this.$forceUpdate();
          setTimeout(() => {
            this.purchaseForm.validation.main = null
            this.$forceUpdate();
          }, 4000);
        },
        purchaseFunction: function () {
          console.log("this.purchaseForm", this.purchaseForm)

          this.purchaseForm.validation.main = null
          this.purchaseForm.status = "loading"
          this.purchaseForm.data.email = this.purchaseForm.data.email.trim()
          //this.purchaseForm.data.currency = "USD"

          this.stripe.createPaymentMethod('card', this.cardElement, {
              billing_details: { name: this.purchaseForm.data.name }
          }).then(result => {
              if (result.error) {
                  console.log("error", result.error)

                  this.purchaseForm.validation.main = result.error.message
                  this.purchaseForm.status = "error"

              } else {
                  this.purchaseForm.data.stripe_intent = { payment_method_id: result.paymentMethod.id, card_data: result.paymentMethod.card }

                  axios
                    .post('https://api.cursed-tales.com/purchases' + (this.$developer ? '?developer=true' : ''), this.purchaseForm.data)
                    .then(response => {
                      console.log("response.data", response)
                      sessionStorage.setItem('Cursed_CustomerReference', response.data.reference)
                      this.$cookies.set('Cursed_CustomerReference', response.data.reference, 60 * 60 * 24)
                      this.$store.dispatch("setAuth", response.data)
                      this.purchaseSuccess = true
                      this.pushMfqVariable("PURCHASE", "THEMOTHER");
                      this.$fbq('track', 'Purchase', {currency: this.purchaseForm.data.currency, value: this.purchaseForm.data.total});
                    })
                    .catch(error => {
                      console.log(error.response)

                      if (error.response.data.error && error.response.data.error.type == "intent_action") {
                        this.authorisationResponse = error.response.data.error.action;
                        this.authorisation = true;

                        this.stripe.handleCardAction(this.authorisationResponse.payment_intent_client_secret).then(result => {
                            if (result.error) {
                              this.purchaseForm.error_messages = result.error.message
                              this.purchaseForm.status = "error";

                            } else {
                                this.purchaseForm.data.stripe_intent = { payment_intent_id: result.paymentIntent.id, payment_id: this.authorisationResponse.payment_id || 0 }

                                axios
                                  .post('https://api.cursed-tales.com/purchases', this.purchaseForm.data)
                                  .then(response => {
                                    console.log("response.data", response)
                                    sessionStorage.setItem('Cursed_CustomerReference', response.data.reference)
                                    this.$cookies.set('Cursed_CustomerReference', response.data.reference, 60 * 60 * 24)
                                    this.$store.dispatch("setAuth", response.data)
                                    this.purchaseSuccess = true
                                    this.$fbq('track', 'Purchase', {currency: this.purchaseForm.data.currency, value: this.purchaseForm.data.total});
                                  })
                                  .catch(error => {
                                    console.log(error.response)
                                      this.purchaseForm.error_messages = error.response.data.error.validation_failed
                                      this.purchaseForm.status = "error";
                                  })

                            }
                        });

                      } else {
                        this.purchaseForm.validation.main = error.response.data.error.message
                        if (error.response.data.error.validation_failed)
                          this.purchaseForm.error_messages = error.response.data.error.validation_failed
                        this.purchaseForm.status = "error";

                      }
                    })
              }
          })
        },
        toggleCardDetails(timeout) {
          this.showCardDetails = true
          setTimeout(() => {
            this.stripe  = window.Stripe(this.$pk)
            this.elements = this.stripe.elements();
            this.cardElement = this.elements.create('card', {
              style: {
                base: {
                  iconColor: '#c4f0ff',
                  color: '#333',
                  backgroundColor: '#ddd',
                  fontWeight: '400',
                  fontFamily: 'Arial, sans-serif',
                  fontSize: '18px',
                  fontSmoothing: 'antialiased',
                  ':-webkit-autofill': {
                    color: '#fce883',
                  },
                  '::placeholder': {
                    color: '#aaa',
                  },
                },
                invalid: {
                  iconColor: '#E42C3E',
                  color: '#E42C3E',
                },
              },
            });

            this.cardElement['addEventListener']('change', (event) => {
                this.purchaseForm.validation.main = null
                if (event.error)
                  this.purchaseForm.validation.main = event.error.message;
                this.$forceUpdate();
            });
            this.cardElement.mount('#card-element')
          }, timeout);
        },
        changeRouteTo(route) {
          this.closeForm()
          window.scrollTo(0, 0)
          this.$router.push({ name: route })
        },
        logOut() {
            sessionStorage.removeItem('Cursed_CustomerReference')
            this.$cookies.remove('Cursed_CustomerReference')
            this.$store.dispatch("setAuth", null)
            this.authed = null
            this.purchaseForm.validation.name = ['required']
            this.purchaseForm.validation.email = ['required','email']
            this.purchaseForm.validation.password = ['required']
            this.showCardDetails = true
        },
        closeForm() {
            this.$emit('close-form', true)
        }
    },
    mounted: function() {
        this.authed = this.getAuth
        if (this.authed) {
          this.purchaseForm.data.customer_id = this.authed.id
          this.purchaseForm.data.name = this.authed.name
          this.purchaseForm.data.email = this.authed.email
          //this.toggleCardDetails(500)
          this.purchaseForm.validation.name = []
          this.purchaseForm.validation.email = []
          this.purchaseForm.validation.password = []
        }
        this.toggleCardDetails(500)

        this.purchaseForm.data.tale_id = this.tale_id
        this.purchaseForm.data.type = this.type;

        this.setCurrency()
        if ((this.$defaultPromotion || this.promotion) && this.type != "Collection") {
            this.purchaseForm.data.discount = this.$defaultPromotion || this.promotion
            this.checkApplyDiscount()
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkout-form {
    padding: 20px;
    background: #711414;
    -moz-box-shadow: 0 0 3px #000;
    -webkit-box-shadow: 0 0 3px #000;
    box-shadow: 0 0 20px #000;
}
.checkout-form h3 {
    font-family: 'Andada Pro', sans-serif;
    color: #fff;
    font-size: 40px;
    padding-bottom: 0px;
    text-align: center;
}
.checkout-form .closeForm {
    position: absolute;
    top: 20px;
    right: 20px;
}
.checkout-form .closeForm i {
    font-size:  40px;
    color: #fff;
    cursor: pointer;
}
.checkout-form .closeForm i:hover {
    color: #aaa;
}

.checkout-form .giftOption {
    color: #75de78;
    font-size: 25px;
    margin-left: 4px;
    margin-bottom: 20px;
    text-align: center;
    border-bottom: 2px solid #7e1a1a;
    padding-bottom: 20px;
}
.checkout-form form .giftMessage {
    border-bottom: 2px solid #7e1a1a;
    padding-bottom: 20px;
    margin-bottom: 20px
}

.checkout-form form p.giftHelp {
    margin: 0 0 20px;
    font-size: 14px;
    color: #aaa;
}

.form-group h4 {
  font-family: 'Andada Pro', sans-serif;
  color: #fff;
  font-size: 24px;
  margin: 0 0 20px 5px;
}
.form-group h4 a {
  color: #aaa;
}
.form-group .authorised {
  padding: 0 5px;
}
.form-group .authorised a,
.form-group .authorised p {
  font-family: 'Andada Pro', sans-serif;
  color: #eee;
  font-size: 19px;
}
.form-group .authorised a.login {
  display: block;
  padding-bottom: 20px;
}
.form-group .authorised p a {
  color: #e5bf08;
  text-decoration: underline !important;
}

.seperator {
  min-height: 10px;
  margin-bottom: 20px;
  border-bottom: 2px solid #7e1a1a;
}

.form-group.nextStep {
  text-align: right;
}
.form-group.nextStep a,
a.toAccount {
    color: #fff;
    padding: 10px;
    border: 3px solid #fff;
    border-radius: 5px;
    font-size: 20px;
    font-weight: 700;
}
.form-group.nextStep a:hover,
a.toAccount:hover {
    color: #aaa;
    border: 3px solid #aaa;
}
a.toAccount {
    margin: 0;
    display: inline-block;
}

.forgotPassword {
  text-align: right;
}
.forgotPassword a {
  color: #fff !important;
}

.form-group.checkBoxWrapper .checkBox {
  display: inline-block;
  float: left;
  width: 25px;
  height: 25px;
  border: 2px solid #fff;
  border-radius: 2px;
  margin: 10px 10px 0 0;
  cursor: pointer;
}
.form-group.checkBoxWrapper .checkBox.activated {
  border: 2px solid #2dab3d;
}
.form-group.checkBoxWrapper .checkBox i {
  font-size: 20px;
  line-height: 22px;
  margin-left: 1px;
  color: #2dab3d;
}
.form-group.checkBoxWrapper label {
  display: block;
  margin-top: 10px;
}

.promotionalWrapper {
  padding-top: 10px;
}
.promotionalWrapper label {
  color: #e5bf08;
  width: 100%;
  text-align: left;
  cursor: pointer;
}
.promotionalWrapper .promotionalField input {
  float: left;
  width: 200px;
  font-family: 'Arial', sans-serif;
  color: #333;
  background: #ddd;
  padding: 6px;
  border: 3px solid #000;
  border-radius: 5px;
  margin-bottom: 10px;
}
.promotionalWrapper .promotionalField input::placeholder {
  color: #222;
}
.promotionalWrapper .promotionalField input:active,
.promotionalWrapper .promotionalField input:focus {
  border-color: #888;
}
.promotionalWrapper .promotionalField .promotionalBtn {
  float: left;
  margin-left: 10px;
  color: #fff;
  padding: 5px;
  border: 3px solid #fff;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 700;
}
.promotionalWrapper .promotionalField .promotionalBtn:hover {
  color: #aaa;
  border: 3px solid #aaa;
}
.promotionalWrapper .promotionalField .discountMessage.messageSuccess {
  margin: 5px 0;
  color: #279f0a
}
.promotionalWrapper .promotionalField .discountMessage.messageError {
  margin: 5px 0;
  color: #000
}
.spamWarning {
  color: #ccc !important;
  font-size: 18px;
}
.form-footer .errorMsg {
  text-align: right;
  margin: 0;
}
.form-footer .priceInformation {
  border-top: 2px solid #cc2626;
  margin-top: 25px;
  padding-top: 10px;
}
.form-footer .priceInformation p {
    color: #fff;
    font-size: 25px;
    margin-bottom: 0;
}
.form-footer .priceInformation p.totalPrice {
    color: #ccc;
    font-size: 20px;
}
.form-footer .priceInformation span {
  color: #fff;
  font-weight: 900;
}
.form-footer .priceInformation span.discounted {
  text-decoration: line-through;
  color: #000;
}
.supported-payments {
    padding-top: 20px;
    text-align: center;
    margin-bottom: 10px;
}
.supported-payments li {
    padding: 0 2px;
}
.cancelForm {
    position: relative;
    display: block;
    width: 100%;
    padding-top: 10px;
    font-size: 20px;
    color: #fff;
    text-align: center;
}

@media (max-width:992px) {
  .checkout-form {
    width: 100%;
  }
}
@media (max-width: 400px) {
  .checkout-form .col-6 {
    width: 100%;
  }
}
</style>
